import { axiosApi, createCRUD } from '@/api/axios';

export default {
  ...createCRUD('users'),
  updateUserData(id, userData) {
    return axiosApi.patch(`/users/${id}/admin_update`, userData);
  },
  getDashboardData(params) {
    return axiosApi.get('/users/dashboard', { params });
  },
  recoverUserPassword(email) {
    return axiosApi.post('/passwords/recover', { email });
  },
  getSimpleIndex(params) {
    return axiosApi.get('/users/simple_index', { params });
  },
  getBackendVersion() {
    return axiosApi.get('/users/version_hash');
  },
  replacements: {
    ...createCRUD('replacements'),
  },
};
